import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ScrollManager from './ScrollManager';
import '../styles/Layout.css';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({children}) => {
    return (
        <>
            <ScrollManager/>
            <div className="layout-container">
                <Header/>
                <main className="main-content-wrapper">
                    {children}
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Layout;